/**
 * Czysta logika stref przejść krawędziowych — bez Phaser.
 */
import type { ColliderRect, EdgeZone } from './types.js';

/** Punkt w prostokącie (włącznie z krawędziami). */
export function pointInRect(px: number, py: number, rect: ColliderRect): boolean {
  return (
    px >= rect.x &&
    px <= rect.x + rect.width &&
    py >= rect.y &&
    py <= rect.y + rect.height
  );
}

/**
 * Zwraca pierwszą strefę zawierającą punkt, albo null.
 * Kolejność = kolejność tablicy (scena ustala priorytet).
 */
export function pickEdgeZone(
  x: number,
  y: number,
  zones: readonly EdgeZone[],
): EdgeZone | null {
  for (const z of zones) {
    if (pointInRect(x, y, z.rect)) return z;
  }
  return null;
}

/**
 * Buduje domyślne strefy przy 4 krawędziach świata (pas `band` px).
 * Użyteczne w Town (Osiedle / Rynek / Pole) — sceny mogą podać własne.
 */
export function makeCardinalEdgeZones(
  worldW: number,
  worldH: number,
  band = 48,
): EdgeZone[] {
  return [
    {
      id: 'edge-west',
      rect: { x: 0, y: 0, width: band, height: worldH },
      targetKey: 'west',
      labelPl: 'Zachód',
    },
    {
      id: 'edge-east',
      rect: { x: worldW - band, y: 0, width: band, height: worldH },
      targetKey: 'east',
      labelPl: 'Wschód',
    },
    {
      id: 'edge-north',
      rect: { x: 0, y: 0, width: worldW, height: band },
      targetKey: 'north',
      labelPl: 'Północ',
    },
    {
      id: 'edge-south',
      rect: { x: 0, y: worldH - band, width: worldW, height: band },
      targetKey: 'south',
      labelPl: 'Południe',
    },
  ];
}
